import React from "react";
import {
    ChevronUpDownIcon,
    CheckIcon,
} from "@heroicons/react/24/outline";
import {
    Listbox,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
} from "@headlessui/react";
import Datepicker from "react-tailwindcss-datepicker";
import { formatNumber } from "../components/utils/utils";
import Counter from "../components/Global/Counter";


const UserFilterComponent = ({
    title,
    selectedDomain,
    onDomainSelect,
    domainlist,
    dateValue,
    onDateSelect,
    onFilterApply,
    userInfo,
}) => {
    return (
        <div className="text-gray-50 bg-white rounded-2xl">
            <div className="mx-auto">
                <div className="px-8 py-6 flex flex-wrap lg:flex-nowrap items-center md:justify-between border-b border-gray-200">
                    <div className="min-w-full lg:min-w-0 flex-1 mb-4 lg:mb-0">
                        <h2 className="text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                            {title}
                        </h2>
                    </div>
                    <div className="flex flex-wrap lg:flex-nowrap w-full lg:w-auto flex-shrink-0 md:ml-4 md:mt-0 items-center">
                        {/* Dropdown for domain selection */}
                        <div className="mr-0 lg:mr-4 w-full lg:w-40 mb-3 lg:mb-0">
                            <Listbox value={selectedDomain} onChange={onDomainSelect}>
                                <div className="relative">
                                    <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-2.5 pl-4 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm/6">
                                        <span className="block truncate text-gray-600">
                                            {selectedDomain?.name || "Select domain"}
                                        </span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <ChevronUpDownIcon
                                                aria-hidden="true"
                                                className="size-5 text-gray-400"
                                            />
                                        </span>
                                    </ListboxButton>
                                    <ListboxOptions
                                        className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
                                    >
                                        {domainlist?.map((list) => (
                                            <ListboxOption
                                                key={list.id}
                                                value={list}
                                                className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-indigo-600 hover:text-white"
                                            >
                                                <span className="block truncate font-normal">
                                                    {list?.name || ''}
                                                </span>
                                                <span
                                                    className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-hover:block"
                                                >
                                                    <CheckIcon aria-hidden="true" className="size-5" />
                                                </span>
                                            </ListboxOption>
                                        ))}
                                    </ListboxOptions>
                                </div>
                            </Listbox>
                        </div>

                        {/* Datepicker */}
                        <div className="mr-0 lg:mr-4 w-full lg:w-64 mb-3 lg:mb-0">
                            <div className="border border-gray-300 rounded-md shadow-sm">
                                <Datepicker
                                    asSingle={true}
                                    primaryColor="red"
                                    value={dateValue}
                                    onChange={onDateSelect}
                                    showShortcuts={true}
                                    placeholder="Select date..."
                                />
                            </div>
                        </div>

                        {/* Apply Filter */}
                        <div className="w-full lg:w-20">
                            <button
                                type="button"
                                onClick={onFilterApply}
                                className="w-full text-center rounded-full bg-red-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
                <dl className="grid grid-cols-1 lg:grid-cols-4">
                    {userInfo?.map((item, index) => (
                        <div
                            key={item?.id}
                            className="relative px-4 sm:px-10 py-6 sm:py-8 border-r-0 lg:border-r last:border-r-0 border-b lg:border-b-0"
                        >
                            <div className="flex justify-start items-center">
                                <div>
                                    <div className={`rounded-full p-5 ${item?.bg}`}>
                                        <item.icon
                                            aria-hidden="true"
                                            className={`w-8 h-8 ${item?.iconcolor}`}
                                        />
                                    </div>
                                </div>
                                <dd className="ml-4">
                                    <p className="truncate text-sm font-medium text-gray-500">
                                        {item?.name || ''}
                                    </p>
                                    <p
                                        className={`${index === 0 ? "text-5xl font-extrabold" : "text-3xl font-bold"
                                            } text-gray-900`}
                                    >
                                        
                                        <Counter target={`${formatNumber(item?.stat || 0)}`} />
                                    </p>
                                </dd>
                            </div>
                        </div>
                    ))}
                </dl>
            </div>
        </div>
    );
};

export default UserFilterComponent;
